/**
 * RFC-146 Phase 0 — Tier helper, single source of truth.
 *
 * Replaces all inlined `tier === 'premium' || tier === 'paid' || tier === 'admin'`
 * expressions across the codebase. Adding `'teacher'` here grants premium-equivalent
 * access to teachers in one place instead of editing 25 files every time the tier
 * union changes.
 *
 * The corresponding backend helper is `supabase/functions/_shared/tier-protection.ts`.
 */

import type { UserTier } from '@/config/tiers';

export const PREMIUM_EQUIVALENT_TIERS: readonly UserTier[] = [
  'premium',
  'paid',
  'admin',
  'teacher',
] as const;

/**
 * Returns true when the given tier should be treated as premium-equivalent
 * (i.e. unlocks premium features and suppresses upgrade nudges).
 */
export function isPremiumTier(tier: string | null | undefined): boolean {
  return !!tier && (PREMIUM_EQUIVALENT_TIERS as readonly string[]).includes(tier);
}
